// generated from 1_419 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedWebhookCampaignFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_webhook_campaign_filter"),
  comparison_key: z.enum([
    "6", // 857 (60.39%)
    "4", // 292 (20.58%)
    "12", // 209 (14.73%)
    "5", // 45 (3.17%)
    "3", // 16 (1.13%)
  ]),
  display_name: z.string(),
  // undefined: 1_105 (77.87%), defined 314 (22.13%)
  raw_value: z
    .union([
      // number samples: 241 (76.75%)
      // integer: 38 (15.77%)
      // avg: 1.35, min: 0.041666666666666664, max: 13
      z.number().nonnegative(),
      // string samples: 73 (23.25%)
      common.date,
    ])
    .optional(),
  value: z.union([
    // number samples: 1_152 (81.18%)
    // integer: 240 (20.83%)
    // avg: 1.74, min: 0.041666666666666664, max: 21
    z.number().nonnegative(),
    // string samples: 267 (18.82%)
    common.date,
  ]),
  varies_by_app_group: z.literal(false),
});
